import React from 'react'
import './FasesSection.css';

const FasesSection = ({ title, imageUrl, altText }) => {
  return (
    <section className="fases-section py-12 md:py-16 bg-white environmental-theme">
      <div className="container mx-auto px-4">
        {title && (
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--text-primary)]">{title}</h2>
          </div>
        )}
        <div className="flex justify-center">
          <img 
            src={imageUrl} 
            alt={altText || title} 
            className="max-w-full h-auto rounded-lg shadow-xl" 
          />
        </div>
      </div>
    </section>
  );
};

export default FasesSection;